import { reactive } from 'vue';
import { MODAL_MODES } from 'dashboard/routes/dashboard/draftMessages/components/constants';

export const conversationModalStore = reactive({
  showNewConversation: false,
  options: {},

  openNewConversation(options = { contactId: null }) {
    this.options = options;
    this.showNewConversation = true;
  },

  closeNewConversation() {
    this.options = {};
    this.showNewConversation = false;
  },

  newDraftModal({ updateUISettings, store, contactId }) {
    store
      .dispatch('drafts/create', { contact_id: contactId })
      .then(newDraft => {
        if (!newDraft || !newDraft.id) return;

        updateUISettings({
          editing_draft_id: newDraft.id,
          draft_compose_mode: MODAL_MODES.EDITING,
        });
      });
  },
});
